export default {
      id: "volume-app-usage",
      viewBox: "0 0 42 48",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#volume-app",
      toString: function () {
        return this.url;
      }
    }